import React from 'react';

import classNames from 'classnames';

import {
  ImageWithSize,
  Props as ImageWithSizeProps,
} from '../ImageWithSize/ImageWithSize';
import styles from './ImageWithSizeLoadingBlock.module.css';

export type Props = ImageWithSizeProps & {
  height: number;
  loadingBlockStyle?: React.CSSProperties;
  width: number;
};

export const hooks = {
  useGetStates() {
    const [loaded, setLoaded] = React.useState(false);
    return {
      loaded,
      setLoaded,
    };
  },
  useGetHandleLoadedState(setLoaded: React.Dispatch<React.SetStateAction<boolean>>) {
    const handleLoadedState = React.useCallback(() => {
      setLoaded(true);
    }, [setLoaded]);
    return { handleLoadedState };
  },
};

export const ImageWithSizeLoadingBlock = React.memo((props: Props) => {
  const {
    height,
    width,
    loadingBlockStyle,
    ...rest
  } = props;

  const {
    loaded,
    setLoaded,
  } = hooks.useGetStates();

  const { handleLoadedState } = hooks.useGetHandleLoadedState(setLoaded);

  return (
    <div
      style={{
        width,
        height,
        ...loadingBlockStyle,
      }}
      className={classNames(styles.wrapper, {
        [styles.loadingCard]: !loaded,
      })}
    >
      <ImageWithSize
        {...rest}
        onLoadCallback={handleLoadedState}
        className={classNames(styles.img, {
          [styles.hiddenIfUnloaded]: !loaded,
        })}
      />
      {!loaded && (<div className={classNames(styles.gradient)} />)}
    </div>
  );
});

ImageWithSizeLoadingBlock.displayName = 'ImageWithSizeLoadingBlock';
